import { gql } from "@apollo/client";

export const getGamesResQuery = gql`
query getGamesResponses($phone_number: String = "", $games_id: bigint = "0", $survey_id: bigint = "0") {
  users(where: {phone_number: {_eq: $phone_number}}) {
    id
    name
    phone_number
    survey_responses(where: {survey_id: {_eq: $survey_id}}) {
      response_details
    }
    game_responses(where: {game_id: {_eq: $games_id}}) {
      outcome
      success
      id
    }
  }
}
`